import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '@shared/services/auth.service'
import { Subscription } from 'rxjs'
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms'
import { PublicPageTitleService } from '../../services/public-page-title.service'
import { faUserCircle, faUser, faSignOutAlt, faBars, faTimes } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss'],
  standalone: false,
})
export class PublicHeaderComponent implements OnInit, OnDestroy {
  isLoggedIn: boolean
  subscriptions: Subscription[] = []
  loginForm: UntypedFormGroup
  pageTitle = ''
  sideNavOpen = false
  faBars = faBars
  faTimes = faTimes

  faUserCircle = faUserCircle
  faUser = faUser
  faSignOutAlt = faSignOutAlt

  constructor(private authService: AuthService, private publicPageTitleService: PublicPageTitleService) {
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      password: new UntypedFormControl('', Validators.required),
    })
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.authService.userLoggedinEvent.subscribe(isLoggedIn => {
        this.isLoggedIn = isLoggedIn
      })
    )

    this.isLoggedIn = this.authService.isLoggedIn()

    this.subscriptions.push(
      this.publicPageTitleService.pageTitle$.subscribe(title => {
        this.pageTitle = title
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe())
  }

  onLogout(): void {
    this.authService.logout()
  }

  toggleSideNav(): void {
    this.sideNavOpen = !this.sideNavOpen
  }
  closeSideNav(): void {
    this.sideNavOpen = false
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth >= 992 && this.sideNavOpen) {
      this.closeSideNav()
    }
  }
}
